// @flow
export { default } from './ActivityError';
